// Module
var code = `<div class="nutshell-container {{nutshellType}} {{classVal}}">
    <span class="icon"></span>
  <div class="heading-2">{{heading}}</div>

  {{#body}}

  <p>{{.*}}</p>

  {{/body}}
</div>
`;
// Exports
module.exports = code;